import _ from 'lodash';
import async from 'async';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Button from '@material-ui/core/Button';

import VendorBillContainer from '../../containers/billing/VendorBill';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';
import SuppliersContainer from '../../containers/logistics/Suppliers';
import CarriersContainer from '../../containers/logistics/Carriers';
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import FormComponent from '../../components/FormComponent';
import ResourceUploader from '../../components/form/ResourceUploader';
import FMPSubmitButton from '../../components/form/FMPSubmitButton';
import FMPSelect from '../../components/pureForm/FMPSelect';
import MultiPageBillDialog from '../../components/Dialogs/MultiPageBillDialog';
import GenericSavingDialog from '../../components/Dialogs/GenericSavingDialog';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import FMPSplitBillPagesSelect from '../../components/pureForm/FMPSplitBillPagesSelect';
import SplitBillPagesContainer from '../../containers/billing/SplitBillPage';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import ConfirmInvalidateVendorBillDialog from '../../components/Dialogs/ConfirmInvalidateVendorBillDialog';

import {
	save,
	vendorStyles,
	getTermsFromCarrier,
	getTermsFromSupplier,
	searchForInvoiceMatch,
	renderSearchResult,
	renderMatchStatus,
	renderFreightLineItems,
	renderFuelLineItems,
	renderInvoiceDetails,
	renderInvoiceMatches,
	renderBillFields,
	renderBillTotal,
	renderMarkTransfer,
	renderOrders,
	renderSearchResultOrCurrentLinkage,
} from './vendorBillShared';

const styles = (theme) => {
	return {
		...vendorStyles(theme),
	};
};

class VendorBillSave extends FormComponent {
	constructor(props) {
		super(props);
		const vendorBillId = _.get(this.props, ['match', 'params', 'vendorBillId']);

		this.state = {
			isUpdate: vendorBillId,
			vendorBillId: vendorBillId ? parseInt(vendorBillId, 10) : undefined,

			formFieldError: {},
			invoiceDocuments: [],

			//- Default form values
			isConfirmationOpen: false,
			isSavingOpen: false,
			savingStatus: undefined,

			isMultiPageBillDialogOpen: false,

			//- temp
			//typeOfBill : 'fuel',

			vendorBillOrders: [
				{
					bolNumberToInvoiceIdHash: {},
					carrierPoNumberToInvoiceIdHash: {},
					vendorBillOrderLineItems: [{}],
					isRackToRackTransfer: false,
					isInventoryTransfer: false,
				},
			],
			searchResultsForOrder: [],
			isSearchingForOrder: [],
			isConfirmInvalidateOpen: false,
		};
	}

	componentDidMount() {
		const {
			vendorBill,
			getVendorBill,
			quickbooksTerms,
			searchQuickbooksTerms,
			suppliers,
			searchSuppliers,
			carriers,
			searchCarriers,
		} = this.props;

		const { isUpdate, vendorBillId } = this.state;

		if (_.isEmpty(quickbooksTerms)) {
			searchQuickbooksTerms();
		}

		if (_.isEmpty(suppliers)) {
			searchSuppliers();
		}

		if (_.isEmpty(carriers)) {
			searchCarriers();
		}

		if (!isUpdate) {
			return;
		}

		if (!vendorBill) {
			getVendorBill({
				params: { vendorBillIds: [vendorBillId] },
			});
		} else {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (_.isUndefined(prevProps.vendorBill) && !_.isUndefined(this.props.vendorBill)) {
			const newState = this.fillForm();
			this.setState(newState);
		}

		const newState = {};
		if (prevState.supplierId !== this.state.supplierId) {
			this.getTermsFromSupplier({
				newState,
				supplierId: parseInt(this.state.supplierId, 10),
			});
		}

		if (prevState.carrierId !== this.state.carrierId) {
			this.getTermsFromCarrier({
				newState,
				carrierId: parseInt(this.state.carrierId, 10),
			});
		}

		if (!_.isEmpty(newState)) {
			this.setState(newState);
		}
	}

	fillForm = () => {
		const { vendorBill, resourceMap, showErrors } = this.props;
		if (!vendorBill) {
			return;
		}

		const newState = {};
		[
			'typeOfBill',
			'supplierId',
			'carrierId',
			'quickbooksVendorId',
			'billNumber',
			'quickbooksTermId',
			'billDate',
			'vendorBillOrders',
		].forEach((key) => {
			if (_.isNil(vendorBill[key])) {
				return;
			}
			newState[key] = vendorBill[key];
		});

		const { vendorDocumentResourceId, vendorCsvResourceId, vendorBillOrders } = vendorBill;

		if (vendorDocumentResourceId) {
			const resource = resourceMap[vendorDocumentResourceId];
			if (!resource) {
				return showErrors([`Cant find document. Resource id : ${vendorDocumentResourceId}`]);
			}
			newState.vendorDocumentResource = resource;
		}

		if (vendorCsvResourceId) {
			const resource = resourceMap[vendorCsvResourceId];
			if (!resource) {
				return showErrors([`Cant find CSV. Resource id : ${vendorCsvResourceId}`]);
			}
			newState.vendorCsvResource = resource;
		}

		if (_.isArray(vendorBillOrders)) {
			vendorBillOrders.forEach((vendorBillOrder) => {
				const { bolNumberToInvoiceIds, carrierPoNumberToInvoiceIds } = vendorBillOrder;
				vendorBillOrder.bolNumberToInvoiceIdHash = {};
				vendorBillOrder.carrierPoNumberToInvoiceIdHash = {};

				if (_.isArray(bolNumberToInvoiceIds)) {
					bolNumberToInvoiceIds.forEach((bolNumberToInvoiceId) => {
						vendorBillOrder.bolNumberToInvoiceIdHash[bolNumberToInvoiceId] = true;
					});
				}

				if (_.isArray(carrierPoNumberToInvoiceIds)) {
					carrierPoNumberToInvoiceIds.forEach((carrierPoNumberToInvoiceId) => {
						vendorBillOrder.carrierPoNumberToInvoiceIdHash[carrierPoNumberToInvoiceId] = true;
					});
				}
			});
		}

		return newState;
	};

	getTermsFromSupplier = getTermsFromSupplier.bind(this);
	getTermsFromCarrier = getTermsFromCarrier.bind(this);

	//- Dialogs
	closeSavingDialog = () => {
		this.setState({ onContinue: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/billing/vendorBills`);
	};

	handleSaveProgress = () => {
		const { showErrors } = this.props;
		this.save({
			callback: (err, r) => {
				if (err) {
					this.setState({ isSavingOpen: false });
					return showErrors(_.isArray(err) ? err : [err]);
				}

				const vendorBill = _.get(r, ['collections', 'vendorBillCollection', 0]);
				if (!vendorBill) {
					this.setState({ isSavingOpen: false });
					return showErrors(['Save did not return a vendor bill']);
				}

				this.setState({
					savingStatus: 'done',
				});
			},
		});
	};

	handleSaveAndExport = () => {
		const { showErrors } = this.props;

		async.waterfall(
			[
				(callback) => {
					this.save({
						callback,
					});
				},
				(r, callback) => {
					const vendorBill = _.get(r, ['collections', 'vendorBillCollection', 0]);
					if (!vendorBill) {
						return callback('Save did not return a vendor bill');
					}

					const { vendorBillId } = vendorBill;
					this.props.exportVendorBill({
						params: {
							vendorBillId,
						},
						callback,
					});
				},
			],
			(err) => {
				if (err) {
					this.setState({ isSavingOpen: false });
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.setState({
					savingStatus: 'done',
				});
			}
		);
	};

	save = save.bind(this);
	addOrder = () => {
		const arrayName = 'vendorBillOrders';
		this.setState({
			[arrayName]: this.state[arrayName].concat([
				{
					bolNumberToInvoiceIdHash: {},
					carrierPoNumberToInvoiceIdHash: {},
					vendorBillOrderLineItems: [{}],
				},
			]),
		});
	};

	removeOrder = ({ orderIndex }) => {
		const arrayName = 'vendorBillOrders';
		const inputs = this.state[arrayName].slice();
		inputs.splice(orderIndex, 1);
		this.setState({ [arrayName]: inputs });
	};

	addLineItem = ({ orderIndex }) => {
		//- Check to see if I have a quantity from the previous orderIndex and autofill that
		const { vendorBillOrders } = this.state;
		let quantity = '';

		if (_.isObject(vendorBillOrders[orderIndex])) {
			const { vendorBillOrderLineItems } = vendorBillOrders[orderIndex];
			const lastLineItem = _.last(vendorBillOrderLineItems);
			if (_.isObject(lastLineItem)) {
				quantity = lastLineItem.quantity;
			}
		}

		this.setState((currentState) => {
			const { vendorBillOrders } = currentState;
			const newOrders = update(vendorBillOrders, {
				[orderIndex]: {
					vendorBillOrderLineItems: { $push: [{ quantity }] },
				},
			});
			return { vendorBillOrders: newOrders };
		});
	};

	removeLineItem = ({ orderIndex, lineItemIndex }) => {
		this.setState((currentState) => {
			const { vendorBillOrders } = currentState;
			const newOrders = update(vendorBillOrders, {
				[orderIndex]: {
					vendorBillOrderLineItems: { $splice: [[lineItemIndex, 1]] },
				},
			});
			return { vendorBillOrders: newOrders };
		});
	};

	handleDataFileUpload = ({ resource }) => {
		this.setState({ vendorDocumentResource: resource });
	};

	handleInvalidate = () => {
		this.setState({ isConfirmInvalidateOpen: true });
	};

	closeInvalidateDialog = () => {
		this.setState({ isConfirmInvalidateOpen: false });
	};

	searchForInvoiceMatch = searchForInvoiceMatch.bind(this);

	render() {
		const {
			classes,
			vendorBill,
			quickbooksTerms,
			//resourceMap,
			//invalidateTrueUpInvoice,
			//showErrors,
			suppliers,
			carriers,

			splitBillPages,
			resourceMap,
		} = this.props;

		const {
			isUpdate,
			vendorBillId,
			splitBillPageId,
			vendorDocumentResource,
			vendorCsvResource,
			/*
			attachmentResourceId,
			isSendConfirmationOpen,
			isSavingOpen,
			savingStatus,
			trueUpInvoiceForSending,
			isConfirmInvalidateOpen,
			productType,
			*/
		} = this.state;

		//- Check if data is loaded yet
		if (_.isEmpty(quickbooksTerms) || _.isEmpty(carriers) || _.isEmpty(suppliers)) {
			return <div>Fetching information...</div>;
		}

		if (isUpdate && !vendorBill) {
			return <div>Fetching station invoice information...</div>;
		}

		let canExport = true;
		/** @namespace vendorBil.quickbooksBillId **/
		if (vendorBill && vendorBill.quickbooksBillId) {
			canExport = false;
		}

		//const verb = (isUpdate) ? 'Update' : 'Add';
		//let resource;
		//if (attachmentResourceId) {
		//  resource = resourceMap[attachmentResourceId];
		//}

		let infoTitle = vendorBillId ? `Update Bill :  #${vendorBillId}` : `Bill Info`;
		const { typeOfBill } = this.state;

		let hasResource = false;

		let splitBillPage, resource, csvResource;
		if (splitBillPageId) {
			if (_.isEmpty(splitBillPages) || _.isObject(resourceMap)) {
				/** @namespace splitBillPage.billName **/
				splitBillPage =
					_.find(splitBillPages, { splitBillPageId: parseInt(splitBillPageId) }) || {};
				resource = resourceMap[splitBillPage.resourceId] || {};
				hasResource = true;
			}
		} else if (vendorDocumentResource) {
			resource = vendorDocumentResource;
			hasResource = true;
		} else if (vendorCsvResource) {
			csvResource = vendorCsvResource;
			hasResource = true;
		}

		return (
			<Grid container spacing={0}>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<FMPRegionHeader isTop={true} label={infoTitle} />
							<Paper className={classes.paper}>
								<FMPSelect
									{...this.setForm('typeOfBill')}
									label="Type of bill"
									options={[
										{ value: 'fuel', display: 'Fuel Bill' },
										{ value: 'freight', display: 'Freight Bill' },
									]}
								/>

								{!typeOfBill && (
									<div className={classes.pickPlease}>
										Pick type of bill to show appropriate fields
									</div>
								)}

								{typeOfBill && this.renderBillFields()}

								<div style={{ textAlign: 'right', margin: '40px 0px 10px 0px' }}>
									{isUpdate && (
										<Button
											onClick={this.handleInvalidate}
											variant="outlined"
											style={{ margin: '0px 10px' }}
										>
											Mark Invalid
										</Button>
									)}

									<Button
										onClick={this.handleSaveProgress}
										variant="outlined"
										color="primary"
										style={{ margin: '0px 10px' }}
									>
										Save Progress
									</Button>

									{canExport && (
										<FMPSubmitButton
											onClick={this.handleSaveAndExport}
											buttonText={`Save and Export to QB`}
											disabled
										/>
									)}

									{!canExport && (
										<FMPSubmitButton
											onClick={this.handleSaveAndExport}
											buttonText={`Save and Export to QB`}
											isDisabled={true}
											disabledText={'This Vendor Bill has already been exported to quickbooks'}
										/>
									)}
								</div>
							</Paper>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FMPRegionHeader isTop={true} label={`Bill Document`} />
							<Paper
								className={classes.paper}
								style={{ position: 'sticky', top: 10, height: '90vh' }}
							>
								{!hasResource && (
									<Grid container spacing={3} style={{ alignItems: 'flex-end' }}>
										<Grid item xs={12}>
											<ResourceUploader
												name={'dataFileResourceId'}
												label={''}
												afterUpload={this.handleDataFileUpload}
												onlyOne={true}
											/>
										</Grid>
										<Grid item xs={12}>
											<div className={classes.orLine}>
												<span className={classes.orBlock}>OR</span>
											</div>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FMPSplitBillPagesSelect
												{...this.setForm('splitBillPageId')}
												label="Available split bill pages"
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<Button
												variant="outlined"
												color="primary"
												className={classes.addInputButton}
												onClick={this.openMultiPageBillDialog}
											>
												Split a new multi page bill <ChevronRight />
											</Button>
										</Grid>
									</Grid>
								)}

								{hasResource && (
									<Fragment>
										{!!splitBillPage && (
											<div style={{ textTransform: 'uppercase', color: '#666' }}>
												{splitBillPage.billName} - Page {splitBillPage.pageNumber}
											</div>
										)}

										{resource && (
											<object
												data={resource.url}
												style={{ height: '100%', width: '100%', maxWidth: '100%' }}
												type={resource.contentType}
												//width="175"
												//height="175"
											>
												<a href={resource.url}>BillDocument.pdf</a>
											</object>
										)}

										{csvResource && (
											<object
												data={csvResource.url}
												style={{ height: '100%', width: '100%', maxWidth: '100%' }}
												type={csvResource.contentType}
											>
												<p style={{ textAlign: 'center' }}>
													<p style={{ fontSize: '40px', fontWeight: 900, color: '#999' }}>
														CSV File
													</p>
													This bill was imported automatically from LF (Formerly NCP) / PDI FTP.
													<br />
													<br />
													Click this <a href={csvResource.url}>link</a> to download the CSV file if
													you want to inspect its contents.
												</p>
											</object>
										)}
									</Fragment>
								)}
							</Paper>
						</Grid>
					</Grid>

					<MultiPageBillDialog
						open={this.state.isMultiPageBillDialogOpen}
						onClose={this.closeMultiPageBillDialog}
						showErrors={this.props.showErrors}
						history={this.props.history}
					/>

					<GenericSavingDialog
						open={this.state.isSavingOpen}
						onClose={this.closeSavingDialog}
						onContinue={this.continueSavingDialog}
						processingText={'Processing and saving invoice.'}
						successText={'Invoice saved successfully.'}
						status={this.state.savingStatus}
					/>

					<InvoiceDocumentPopup
						open={this.state.isInvoiceDocumentPopupOpen}
						onClose={this.handleCloseInvoiceDocumentPopup}
						invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
						resourceMap={resourceMap}
					/>

					<ConfirmInvalidateVendorBillDialog
						open={this.state.isConfirmInvalidateOpen}
						onClose={this.closeInvalidateDialog}
						vendorBill={vendorBill}
						invalidateVendorBill={this.props.invalidateVendorBill}
						showErrors={this.props.showErrors}
						history={this.props.history}
					/>
				</Grid>
			</Grid>
		);
	}

	renderBillFields = renderBillFields.bind(this);
	renderBillTotal = renderBillTotal.bind(this);
	renderOrders = renderOrders.bind(this);
	renderMarkTransfer = renderMarkTransfer.bind(this);
	renderSearchResultOrCurrentLinkage = renderSearchResultOrCurrentLinkage.bind(this);
	renderSearchResult = renderSearchResult.bind(this);
	renderMatchStatus = renderMatchStatus.bind(this);
	renderInvoiceMatches = renderInvoiceMatches.bind(this);
	renderInvoiceDetails = renderInvoiceDetails.bind(this);
	renderFuelLineItems = renderFuelLineItems.bind(this);
	renderFreightLineItems = renderFreightLineItems.bind(this);

	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentsPoppedUp: invoiceDocuments,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		});
	};

	closeMultiPageBillDialog = () => {
		this.setState({ isMultiPageBillDialogOpen: false });
	};
	openMultiPageBillDialog = () => {
		this.setState({ isMultiPageBillDialogOpen: true });
	};
}

VendorBillSave.propTypes = {
	//- me
	addVendorBill: PropTypes.func.isRequired,
	updateVendorBill: PropTypes.func.isRequired,
	exportVendorBill: PropTypes.func.isRequired,
	getVendorBill: PropTypes.func.isRequired,
	invalidateVendorBill: PropTypes.func.isRequired,
	vendorBill: PropTypes.object,

	//- lists
	searchQuickbooksTerms: PropTypes.func.isRequired,
	quickbooksTerms: PropTypes.array,
	searchSuppliers: PropTypes.func.isRequired,
	quickbooksVendorMap: PropTypes.object,
	suppliers: PropTypes.array,
	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,

	bolNumberToInvoiceMap: PropTypes.object,
	carrierPoNumberToInvoiceMap: PropTypes.object,

	stationInvoiceMap: PropTypes.object,
	bulkInvoiceMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,

	stationMap: PropTypes.object,
	bulkCustomerMap: PropTypes.object,

	carrierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	railcarMap: PropTypes.object,
	invoiceIndex: PropTypes.object,

	//- split bill
	splitBillPages: PropTypes.array,
	resourceMap: PropTypes.object,

	//- misc
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	VendorBillContainer,
	QuickbooksContainer,
	SuppliersContainer,
	CarriersContainer,
	SplitBillPagesContainer,
])(VendorBillSave);
